import type { Board } from "../board";
import { PRIORITY_LAST, type ProcessableThing } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class Smoke extends PhysicalThing implements ProcessableThing {
	static key = "Smoke";
	private timeToLive: number;

	constructor(xy: XY, timeToLive: number = 3) {
		super(xy, false);
		this.timeToLive = timeToLive;
	}

	getZOrder(): number {
		return ZOrder.AIR;
	}

	processTurn(board: Board): void {
		this.timeToLive--;
		if (this.timeToLive <= 0) {
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), timeToLive: this.timeToLive };
	}

	static deserialize(data: any): Smoke {
		const s = new Smoke(deserializeXY(data.xy), data.timeToLive);
		s.visualId = data.visualId;
		return s;
	}
}
